import { useRouter } from 'next/router'

import { appendSearchParams } from 'homepage/utils'

export const useUrlWithParams = (
  url: string | undefined,
  enabled = false
): string | undefined => {
  const { asPath } = useRouter()

  if (!enabled) {
    return url
  }

  const currentSearch = asPath.split('?')[1] ?? ''

  return appendSearchParams(url, currentSearch)
}
